import Cookies from "universal-cookie";
import { isBotUserAgent } from "@/utils/checkUA";

const cookies = new Cookies();

export function getLocale() {
    let cookieLang = new URLSearchParams(window.location.search).get('hintLang') || cookies.get("pref_lang");

    if (cookieLang) {
        return cookieLang;
    } else {
        var browserLang = navigator.language
        if (!browserLang) {
            return 'pt';
        }
        let useLang = null;
        if (browserLang.indexOf("pt") > -1 || isBotUserAgent()) {
            useLang = "pt";
        } else {
            useLang = "en";
        }

        return useLang;
    }
}